var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discount-codes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-113.000000, -2397.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discount-codes",
    transform: "translate(113.000000, 2397.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 235,
    cy: 468,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Discounts_3_line_1c",
    transform: "translate(100.000000, 90.000000)",
    stroke: "#000000",
    strokeWidth: 18.8679245
  }, /*#__PURE__*/React.createElement("line", {
    x1: 270.754717,
    y1: 399.677157,
    x2: 258.084906,
    y2: 412.236957,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.103774,
    y1: 371.575668,
    x2: 286.443396,
    y2: 384.126031,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.764151,106.847939 C394.981132,111.660484 396.226415,117.020338 396.226415,122.67272 C396.226415,143.517646 379.330189,160.418172 358.490566,160.418172 C337.650943,160.418172 320.754717,143.517646 320.754717,122.67272 C320.754717,101.827794 337.650943,84.9272675 358.490566,84.9272675 C360.301887,84.9272675 362.084906,85.0593766 363.830189,85.3047221",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.8679245,
    y1: 66.0545414,
    x2: 66.0377358,
    y2: 66.0545414,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.773585,
    y1: 66.0545414,
    x2: 150.943396,
    y2: 66.0545414,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.9056604,
    y1: 84.9272675,
    x2: 84.9056604,
    y2: 132.109083,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.9056604,
    y1: 0,
    x2: 84.9056604,
    y2: 47.1818153,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.924528,
    y1: 434.072701,
    x2: 415.09434,
    y2: 434.072701,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.830189,
    y1: 434.072701,
    x2: 500,
    y2: 434.072701,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.962264,
    y1: 452.945427,
    x2: 433.962264,
    y2: 500.127242,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.962264,
    y1: 368.018159,
    x2: 433.962264,
    y2: 415.199975,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.490566,122.67272 C358.490566,70.5179411 386.792453,31.4513981 424.528302,28.3090892 C440.169811,28.3090892 452.830189,40.3970703 452.830189,56.6181784 C452.830189,75.3399227 446.669811,86.7673583 435.433962,95.1185396",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.698113,188.727261 L471.698113,245.34544 C471.698113,252.856785 468.716981,260.05673 463.40566,265.359966 L213.90566,512.630423 C209.622642,516.914532 204.169811,519.009405 198.113208,519 C192.075472,518.990532 186.415094,516.65975 181.537736,512.526623 L6.66037736,384.116595 C2.38679245,379.841922 0,374.057432 0,368.018159 L0,311.399981",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.358491,147.801755 C268.735849,159.295245 266.622642,182.706862 250.632075,200.098079 C234.650943,217.489296 210.849057,222.264095 197.471698,210.770605 C184.09434,199.277115 186.207547,175.865498 202.198113,158.474281 C218.179245,141.0925 241.981132,136.308264 255.358491,147.801755 L255.358491,147.801755 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.358491,308.219927 C268.735849,319.713417 266.622642,343.125034 250.632075,360.516251 C234.650943,377.907468 210.849057,382.682268 197.471698,371.188777 C184.09434,359.695287 186.207547,336.28367 202.198113,318.892453 C218.179245,301.510672 241.981132,296.726436 255.358491,308.219927 L255.358491,308.219927 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.160377,
    y1: 292.527255,
    x2: 345.226415,
    y2: 224.708114,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.726415,428.448628 L214.235849,455.691408 C209.490566,459.881154 204.169811,462.391226 198.113208,462.381816 C192.075472,462.372354 186.622642,459.824536 181.40566,455.832954 L6.6509434,327.498416 C2.38679245,323.223744 0,317.439253 0,311.399981 C0,305.370145 2.39622642,299.566782 6.66037736,295.301546 L255.858491,46.0400154 C261.169811,40.727343 268.367925,37.7454522 275.877358,37.7454522 L358.490566,37.7454522 C360.849057,37.7454522 363.009434,38.6135976 364.660377,40.0479248 L449.613208,106.140212 C451.018868,107.366939 452.04717,109.008866 452.528302,110.86783 L471.113208,184.065698 C471.509434,185.660443 471.698113,187.519407 471.698113,188.727261 C471.698113,196.238606 468.716981,203.438551 463.40566,208.741787 L314.537736,356.28876",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.45ce613b5ae37c3e4232fd7b1a2f4d51.svg";
export { ForwardRef as ReactComponent };